import { ETicketStatusGroup } from '../../../types/enums'

/**
 * Бизнес-статусы тикета для мерчантских ролей (оператор / старший оператор).
 *
 * Операторы — это по сути мерчанты, им не нужны внутренние технические состояния воркфлоу.
 * В списках они фильтруют по укрупнённым группам, backend разворачивает группу во внутренние
 * статусы (см. App\Ticket\TicketStatusGroup). Мэтчинг отдельным состоянием здесь не существует —
 * matching-тикеты попадают в те же группы, что и обычные.
 */
export const TICKET_STATUS_GROUP_LABELS: Record<ETicketStatusGroup, string> = {
  [ETicketStatusGroup.ACTIVE]: 'Взят в работу',
  [ETicketStatusGroup.PROCESSING]: 'В обработке',
  [ETicketStatusGroup.COMPLETED]: 'Завершён',
  [ETicketStatusGroup.DECLINED]: 'Отменён',
  [ETicketStatusGroup.EXPIRED]: 'Просрочен',
}

const toOption = (group: ETicketStatusGroup) => ({
  value: group as string,
  label: TICKET_STATUS_GROUP_LABELS[group],
})

/**
 * Нефинальные группы — для вкладок «Активные». Финальные (Завершён / Отменён / Просрочен)
 * сюда не входят: для них есть отдельная вкладка «Завершённые».
 */
const NON_FINAL_STATUS_GROUPS = [
  ETicketStatusGroup.ACTIVE,
  ETicketStatusGroup.PROCESSING,
]

/** Опции фильтра «Статус» на вкладках «Активные» (только нефинальные группы) */
export const ACTIVE_STATUS_GROUP_OPTIONS = NON_FINAL_STATUS_GROUPS.map(toOption)

/** Дефолтный выбор фильтра на вкладках «Активные» */
export const DEFAULT_ACTIVE_STATUS_GROUPS: string[] = [...NON_FINAL_STATUS_GROUPS]
